import { FieldModel } from '../extraction-models';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

export const Sachbearbeiter = {
  vorname: {
    key: 'sachbearbeiter_vorname',
    label: { text: 'Vorname', genus: 'M' },
    type: FieldType.STRING,
    index: 0,
  },
  nachname: {
    key: 'sachbearbeiter_nachname',
    label: { text: 'Nachname', genus: 'M' },
    type: FieldType.STRING,
    index: 1,
  },
  email: {
    key: 'sachbearbeiter_email',
    label: { text: 'E-Mail', genus: 'F' },
    type: FieldType.STRING,
    validators: [Validations.email()],
    index: 2,
  },
  telefon: {
    key: 'sachbearbeiter_telefon',
    label: { text: 'Telefon', genus: 'N' },
    type: FieldType.STRING,
    index: 3,
  },
} satisfies Record<string, FieldModel>;
